export default __webpack_public_path__ + "static/media/W-A-R-logo.872233a0.svg";